import React from "react";
import { Radio, ArrowUpRight, TreePalm, Instagram } from "lucide-react";
import { marketplaces, liveSubtitle } from "../../mock/mock";

const ICONS = { TreePalm, Instagram };

const LiveHeading = () => (
  <div className="text-center mb-14">
    <div className="inline-flex items-center gap-2 mb-4">
      <span className="relative flex h-2.5 w-2.5">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#C8102E] opacity-70" />
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#C8102E]" />
      </span>
      <span className="font-body text-xs font-semibold tracking-wide-sm uppercase text-[#C8102E]">
        Live Now
      </span>
    </div>
    <h2 className="font-display text-4xl md:text-6xl text-[#1A1A1A] mb-4">
      Find Us Live
    </h2>
    <p className="font-body text-[#555] text-sm md:text-base max-w-xl mx-auto">
      {liveSubtitle}
    </p>
  </div>
);

const MarketplaceLogo = ({ marketplace }) => {
  const { logo, name, accent, iconName } = marketplace;
  const Icon = iconName ? ICONS[iconName] : null;

  if (logo) {
    return (
      <img
        src={logo}
        alt={name}
        className="max-h-20 max-w-[70%] w-auto object-contain transition-transform duration-500 group-hover:scale-105"
      />
    );
  }

  return (
    <div className="flex flex-col items-center transition-transform duration-500 group-hover:scale-105">
      {Icon && (
        <span
          className="w-14 h-14 rounded-2xl flex items-center justify-center mb-3"
          style={{ backgroundColor: `${accent}1A` }}
        >
          <Icon size={28} strokeWidth={2} style={{ color: accent }} />
        </span>
      )}
      <span className="font-display text-2xl" style={{ color: accent }}>
        {name}
      </span>
    </div>
  );
};

const MarketplaceCard = ({ marketplace }) => {
  const m = marketplace;
  return (
    <a
      href={m.url}
      target="_blank"
      rel="noopener noreferrer"
      className="group relative w-full sm:w-[calc(50%-12px)] lg:w-[calc(25%-18px)] bg-white border border-[#EEE3E5] rounded-2xl overflow-hidden transition-all duration-400 hover:-translate-y-1.5 hover:shadow-[0_20px_45px_rgba(130,36,50,0.14)]"
    >
      <div className="relative h-40 flex items-center justify-center bg-[#FBF7F8] border-b border-[#F2E7E9] p-6">
        <MarketplaceLogo marketplace={m} />
        <span
          className="absolute top-4 left-4 inline-flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-wide-sm px-2.5 py-1 rounded-full text-white"
          style={{ backgroundColor: m.accent }}
        >
          <Radio size={11} strokeWidth={2.2} /> {m.tag}
        </span>
      </div>
      <div className="flex items-center justify-between p-6">
        <div>
          <h3 className="font-body text-lg font-bold text-[#1A1A1A] leading-tight">
            {m.name}
          </h3>
          <p className="font-body text-sm text-[#888] mt-0.5">{m.handle}</p>
        </div>
        <span className="w-10 h-10 rounded-full bg-[#1A1A1A] flex items-center justify-center transition-colors duration-300 group-hover:bg-[#822432]">
          <ArrowUpRight
            size={18}
            className="text-white transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
          />
        </span>
      </div>
    </a>
  );
};

const FindUsLive = () => {
  return (
    <section id="find-us" className="bg-white py-20 md:py-28">
      <div className="max-w-[1300px] mx-auto px-5 md:px-8">
        <LiveHeading />
        <div className="flex flex-wrap justify-center gap-6">
          {marketplaces.map((m) => (
            <MarketplaceCard key={m.id} marketplace={m} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FindUsLive;
